var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Block',{attrs:{"theme":"orange","title":"预算审批情况"}},[_c('chart-pie',{staticClass:"chart",attrs:{"colors":['#FF9D6B', '#FF72B1', '#FF544C', '#EFF44D', '#FFC328'],"dataList":_vm.showData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }